<script>
import { Radar } from 'vue-chartjs';
import "@/plugins/chart";

export default {
    extends: Radar,
    props: {
        title: {
            type: String,
            default: null,
        },
        labels: {
            type: Array,
            default: () => [],
        },
        datasets: {
            type: Array,
            default: () => [],
        },
        max: {
            type: Number,
            default: 3,
        },
        clean: {
            type: Boolean,
            default: false,
        },
        showValueInPoint: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        data(vm = this) {
            return {
                labels: vm.labels,
                datasets: vm.datasets,
            }
        },
        hasManyDatasets(vm = this) {
            return vm.datasets.length > 1
        },
        options(vm = this) {
            const theme = vm.$vuetify.theme.currentTheme
            const scale = {
                ticks: {
                    beginAtZero: true,
                    max: vm.max,
                    display: false,
                },
                gridLines: { color: theme.outline },
                angleLines: { color: theme.outline },
                pointLabels: {
                    fontSize: 11,
                    fontFamily: '"Outfit", sans-serif',
                },
            }
            if (vm.clean) {
                scale.gridLines = { display: false }
                scale.angleLines = { color: theme.outline }
            }
            return {
                responsive: true,
                maintainAspectRatio: false,
                scale,
                legend: {
                    display: false,
                },
                tooltips: {
                    mode: vm.hasManyDatasets ? 'index' : 'nearest',
                    intersect: !vm.hasManyDatasets,
                    backgroundColor: theme.surface2,
                    titleFontColor: theme.txtPrimary,
                    bodyFontColor: theme.txtSecondary,
                    borderColor: theme.outline,
                    borderWidth: 1,
                    cornerRadius: 8,
                    xPadding: 10,
                    yPadding: 8,
                    titleFontFamily: '"Outfit", sans-serif',
                    bodyFontFamily: '"Outfit", sans-serif',
                    callbacks: {
                        title: function (tooltipItems, data) {
                            const index = tooltipItems[0]?.index
                            return index != null ? data.labels[index] : ''
                        },
                        label: function (tooltipItem, data) {
                            const ds = data.datasets[tooltipItem.datasetIndex]
                            const real = ds.dataReal ? ds.dataReal[tooltipItem.index] : ds.data[tooltipItem.index]
                            return ds.label ? `${ds.label}: ${real}` : `${real}`
                        },
                    }
                },
            }
        }
    },
    mounted() {
        const vm = this
        if (vm.showValueInPoint) {
            vm.addPlugin({
                afterDraw: chart => {
                    const ctx = chart.chart.ctx
                    ctx.save()
                    ctx.textAlign = 'center'
                    ctx.textBaseline = 'middle'
                    chart.data.datasets.forEach((dataset, i) => {
                        const meta = chart.getDatasetMeta(i)
                        if (!meta || meta.hidden) return
                        if (dataset.hidePointLabels) return
                        const radius = Number(dataset.pointRadius) || 11
                        const fontSize = Math.max(7, Math.round(radius * 1.1))
                        ctx.font = `bold ${fontSize}px "Outfit", sans-serif`
                        meta.data.forEach((point, idx) => {
                            const value = dataset.dataReal?.[idx] ?? dataset.data?.[idx]
                            if (value == null) return
                            ctx.fillStyle = '#FFFFFF'
                            ctx.fillText(String(value), point._model.x, point._model.y)
                        })
                    })
                    ctx.restore()
                }
            })
        }
        vm.renderChart(vm.data, vm.options)
    },
    methods: {
        rerender() {
            const vm = this
            vm.renderChart(vm.data, vm.options)
        }
    },
    watch: {
        data() {
            this.rerender()
        },
        options() {
            this.rerender()
        }
    }
};
</script>